import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { find } from 'lodash';
import {
  ReportTemplateFieldCategory,
  ReportTemplatePage,
  ReportTemplateRegion,
  ReportTemplateRegionType,
} from 'src/dto/report-template';
import { TemplateFactory } from '../template-factory';
import { MatCard, MatCardContent } from '@angular/material/card';
import { TemplateCanvasRegionComponent } from './template-canvas-region/template-canvas-region.component';

@Component({
    selector: 'rc-template-canvas',
    templateUrl: './template-canvas.component.html',
    styleUrls: ['./template-canvas.component.less'],
    imports: [MatCard, MatCardContent, TemplateCanvasRegionComponent]
})
export class TemplateCanvasComponent implements OnInit {
  @Input() page: ReportTemplatePage;
  @Output() pageChange: EventEmitter<ReportTemplatePage>;

  regionHeader: ReportTemplateRegion;
  regionMain: ReportTemplateRegion;
  regionData: ReportTemplateRegion;
  regionFooter: ReportTemplateRegion;

  regionHeaderFields: ReportTemplateFieldCategory[];
  regionMainFields: ReportTemplateFieldCategory[];
  regionDataFields: ReportTemplateFieldCategory[];
  regionFooterFields: ReportTemplateFieldCategory[];

  private defaultDroppableFields = [
    ReportTemplateFieldCategory.HeaderData,
    ReportTemplateFieldCategory.TypeData,
    ReportTemplateFieldCategory.Logo,
    ReportTemplateFieldCategory.Miscellaneous,
  ];

  constructor() {
    this.pageChange = new EventEmitter<ReportTemplatePage>();
  }

  ngOnInit() {
    this.regionHeader = this.getRegion(this.page, ReportTemplateRegionType.Header, 5);
    this.regionMain = this.getRegion(this.page, ReportTemplateRegionType.Main, 18);
    this.regionData = this.getRegion(this.page, ReportTemplateRegionType.MeasurementData, 12);
    this.regionFooter = this.getRegion(this.page, ReportTemplateRegionType.Footer, 3);

    this.regionHeaderFields = this.defaultDroppableFields;
    this.regionMainFields = this.defaultDroppableFields;
    this.regionDataFields = this.defaultDroppableFields.concat([
      ReportTemplateFieldCategory.MeasurementData,
    ]);
    this.regionFooterFields = this.defaultDroppableFields;
  }

  onRegionChanged(region: ReportTemplateRegion): void {
    for (let i = 0; i < this.page.regions.length; i++) {
      if (this.page.regions[i].type === region.type) {
        this.page.regions[i] = region;
      }
    }

    this.pageChange.emit(this.page);
  }

  private getRegion(
    page: ReportTemplatePage,
    regionType: ReportTemplateRegionType,
    rows: number
  ): ReportTemplateRegion {
    if (!page || !page.regions) {
      return TemplateFactory.createRegion(ReportTemplateRegionType[regionType], regionType, rows);
    }

    const region = find(this.page.regions, (r) => r.type === regionType);
    return {
      ...region,
      rows: region.rows === 0 ? rows : region.rows,
    };
  }
}
